// extracted by mini-css-extract-plugin
export default {"select":"single-cube_pieces_customize_select"};